import { render } from "./LocationContract.vue?vue&type=template&id=5d0a5be0"
import script from "./LocationContract.vue?vue&type=script&lang=js"
export * from "./LocationContract.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__